package br.com.duoma.duomaproducao.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable


@Serializable
data class WorkCenterExecution(
    val centro_trabalho: String,
    val aponta_anterior: String,
    val qt_produzida: Int,
    val dt_cadastro: LocalDateTime?,
    val celula_producao : String?,
    val ordem: Int
) {
    val workCenter: WorkCenter get() = WorkCenter.fromName(centro_trabalho)
    val boApontaAnteriorCt: Boolean get() = aponta_anterior == "SIM"
}
@Serializable
data class ProductionOrderItemReport(
    val nomeProduto: String,
    val loteId: Int,
    val pedidoVendaId: Int,
    val ordemProducaoItemId: Int,
    val executions: List<WorkCenterExecution>
) {
    fun identifier() = "$nomeProduto $pedidoVendaId $loteId"
}
